import { Matches, TeamLeaguePlayerInfo, TeamPlayerInfo } from '@/entities';
import { MatchesDto } from '@/infrastructure/network/dto/matches/matchesDto';
import { TeamLeaguePlayersResponseDto, TeamPlayersInfoDto } from '@/infrastructure/network/dto/matches/TeamPlayersInfoDto';
import {
	areAllMatchesCompleted,
	areAllPlayersSelectedForMatch,
	calculateAge,
	calculateFinalScore,
	formatCourtTitles,
	formatScoreFormatTitle,
	getProfileImageUrl,
	isTeamLeagueUsingPods
} from '@/infrastructure/utils/helpers';

export const matchesDtoToMatches = (dto: MatchesDto): Matches => {
	return {
		...dto,
		formattedStartDate: dto.plannedStartDate,
		venue: dto.venue ?? '',
		seasonTitle: dto.seasonTitle ?? '',
		winner: dto.winner,
		isAllMatchesCompleted: areAllMatchesCompleted(dto.matches.filter((match) => match.isTieBreaker !== true)),
		isTeamLeagueUsingPods: isTeamLeagueUsingPods(dto.matches),
		roundText: dto.roundText,
		isAllPlayersSelected: areAllPlayersSelectedForMatch(dto.matches),
		courts: formatCourtTitles(dto.matches),
		timezone: dto.timezone,
		matches: dto.matches.map((match) => {
			const gameResults: Array<[number, number]> = [
				[match.teamOneGameOneScore ?? 0, match.teamTwoGameOneScore ?? 0],
				[match.teamOneGameTwoScore ?? 0, match.teamTwoGameTwoScore ?? 0],
				[match.teamOneGameThreeScore ?? 0, match.teamTwoGameThreeScore ?? 0],
				[match.teamOneGameFourScore ?? 0, match.teamTwoGameFourScore ?? 0],
				[match.teamOneGameFiveScore ?? 0, match.teamTwoGameFiveScore ?? 0]
			];

			const { teamOneFinalScore, teamTwoFinalScore } = calculateFinalScore(gameResults, match);

			// Format the score format title and create event title

			const eventTitle = match.isTieBreaker ? 'DreamBreaker' : (match.roundText ?? 'No title for this match');
			const formatedScoreFormatTitle = formatScoreFormatTitle(match.scoreFormatTitle);

			// if (match.playerGroupTitle || match.formatTitle) {
			// 	eventTitle = `${match.playerGroupTitle || ''} ${match.formatTitle || ''}`.trim();
			// }

			return {
				...match,
				timezone: dto.timezone,
				teamOneFinalScore,
				teamTwoFinalScore,
				eventTitle,
				formatedScoreFormatTitle
			};
		})
	};
};

export const teamPlayersInfoDtoToTeamPlayersInfo = (dto: TeamPlayersInfoDto): TeamPlayerInfo[] => {
	return {
		...dto.teamPlayers
	};
};

export const teamPlayersDetailsDtoToTeamPlayersDetails = (dto: TeamLeaguePlayersResponseDto): TeamLeaguePlayerInfo[] => {
	return dto.results.teamLeagueTeamPlayerInfo.map((player) => ({
		...player,
		profilePictureUrl: getProfileImageUrl(player.photo?.profileImage?.url) ?? '',
		dob: calculateAge(player.dateOfBirth) ?? '',
		fullName: `${player.firstName} ${player.lastName}`,
		formattedRatings: {
			doubles: player.ratingDoubles ? player.ratingDoubles.toFixed(2) : 'NR',
			singles: player.ratingSingles ? player.ratingSingles.toFixed(2) : 'NR'
		}
	}));
};
